var map = {
	"./FacecareTermsOfUseText_en.vue": [
		8990,
		990
	],
	"./FacecareTermsOfUseText_ja.vue": [
		8503,
		503
	],
	"./FacecareTermsOfUseText_ko.vue": [
		5276,
		276
	],
	"./FacecareTermsOfUseText_zh-HK.vue": [
		1704,
		704
	],
	"./FacecareTermsOfUseText_zh-TW.vue": [
		2988,
		988
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3284;
module.exports = webpackAsyncContext;